import { xd } from '../utils'; 

// usando o https://www.base64encode.org/ para criptografar
const dev = {
  bUSA: xd('aHR0cDovL2xvY2FsaG9zdDo4MDgw'),
  hashHeader: xd(
    'NDlIOThWMTQ3UTIwNFEyNDBIMjk0WjEzMDlRMzkyJTUwNEsxODcwWTU1MEsyMjQ0WTYzN1k3MjhINzA1JDc2OCM4NTBBODQ2LTk1MFE5NjBIMTAyOVkxMjEwIzQzMDFLMTE1MloxMzI1SzEyMjJRMTI5NlkxMzcyJTEzNjMkMTUwMFoxNzY3IzE4MjQlMTg4MQ=='
  ),
};

const homol = {
  bUSA: xd('aHR0cHM6Ly9hcGkuZmFjaGVzZi5jb20uYnI6MTA0NDMvcmVzdC1wcmV2aWRlbmNpYQ=='),
  hashHeader: xd(
    'NDlIOThWMTQ3UTIwNFEyNDBIMjk0WjEzMDlRMzkyJTUwNEsxODcwWTU1MEsyMjQ0WTYzN1k3MjhINzA1JDc2OCM4NTBBODQ2LTk1MFE5NjBIMTAyOVkxMjEwIzQzMDFLMTE1MloxMzI1SzEyMjJRMTI5NlkxMzcyJTEzNjMkMTUwMFoxNzY3IzE4MjQlMTg4MQ=='
  ),
};

const prod = {

  bUSA: xd('aHR0cHM6Ly9hcGkuZmFjaGVzZi5jb20uYnI6MTA0NDMvcmVzdC1wcmV2aWRlbmNpYQ=='),
  hashHeader: xd(
    'NTdaMTA4SDE1MFkyMDRRMjcwLTExMjJRMzY0SDQyNFYxNjgzLjUwMC41ODMtMjI0NFY2NTBZNzAwWjcwNS43ODQuODUwKjg0NkA5NTBBOTYwVjEwNTAuMTEwMEA0MzAxQDEyMDBBMTI1MFExMjIySDEzMjNRMTQwMFoxMzYzLjE1MDBRMTQ4OFExODI0LjE4ODE='
  ),
};

function SimulacaoPrevidencia() {
  // eslint-disable-next-line no-eval
  return eval(process.env.REACT_APP_HOST_ENV!);
}

export default SimulacaoPrevidencia;